export const insuranceRight = (state) => state.insuranceRight;
export const isLoadingInsuranceRight = (state) => state.isLoadingInsuranceRight;
export const isSavingInsuranceRight = (state) => state.isSavingInsuranceRight;
